const TagOrderType = Object.freeze({
    T4A: 't4a',
    PREPAID: 'pre-paid',
});

export default TagOrderType;
